import { REMOVE, UPDATE } from './ActionTypes';

export function update(payload?: any) {
  return { type: UPDATE, payload };
}

export function remove() {
  return { type: REMOVE };
}

const IntlAction = { update, remove };

export default IntlAction;
